import * as Joi from 'joi';
import {
  getEmailSchema,
  getJoiObject,
  getMasterCodeObjectDropdownSchema,
  getPhoneNumberSchema,
  validateSingaporeCountry,
} from '../../../utils/JoiUtils';
import { IExamMasterCodeItem, LookupListApiItem, LookupListItem } from '../../../api/user/model';

export interface CreateEditCoordinatorSchemaData {
  salutation?: LookupListApiItem;
  coordinatorName?: string;
  privateCentreSchool?: LookupListItem;
  designation?: LookupListApiItem;
  email?: string;
  mobileCountryCode?: IExamMasterCodeItem;
  mobileContactNumber?: string;
  dateOfBirth?: string;
  action?: LookupListApiItem;
  approver?: LookupListApiItem;
  remarks?: string;
  expiryDate?: string;
}

export type CoordinatorProfileResponseIsDisableInputs = {
  [P in keyof CreateEditCoordinatorSchemaData]?: boolean;
};

const CreateEditCoordinatorSchema = (isDisableInputs?: CoordinatorProfileResponseIsDisableInputs) =>
  Joi.object<CreateEditCoordinatorSchemaData>({
    salutation: getMasterCodeObjectDropdownSchema(false, 'Salutation'),
    coordinatorName: Joi.string().required().max(66).messages({
      'any.required': 'Coordinator Name is not allowed to be empty',
      'string.empty': 'Coordinator Name is not allowed to be empty',
      'string.max': 'Coordinator Name is too long',
    }),
    privateCentreSchool: getJoiObject(
      Joi.any().required().messages({
        'number.base': 'Please select school',
        'any.required': 'Please select school',
      }),
      isDisableInputs?.privateCentreSchool
    ),
    designation: getMasterCodeObjectDropdownSchema(false, 'Designation'),
    email: getEmailSchema('Email'),
    mobileCountryCode: getJoiObject(getMasterCodeObjectDropdownSchema(false, 'Country code')),
    mobileContactNumber: Joi.when('mobileCountryCode', {
      is: validateSingaporeCountry,
      then: getPhoneNumberSchema(false, 'Mobile No.', 8, 8),
      otherwise: getPhoneNumberSchema(false, 'Mobile No.'),
    }),
    dateOfBirth: getJoiObject(
      Joi.string().required().messages({
        'any.required': 'Date of birth is not allowed to be empty',
        'string.empty': 'Date of birth is not allowed to be empty',
      }),
      isDisableInputs?.dateOfBirth
    ),
    action: getJoiObject(
      Joi.required().messages({
        'any.required': 'Action is required',
      }),
      isDisableInputs?.action
    ),
    approver: getJoiObject(
      Joi.any().required().messages({
        'any.required': 'Please select Approver.',
      }),
      isDisableInputs?.approver
    ),
    remarks: getJoiObject(
      Joi.string().required().trim().min(1).messages({}),
      isDisableInputs?.remarks
    ),
    expiryDate: getJoiObject(
      Joi.string().required().messages({
        'any.required': 'Expiration Date is not allowed to be empty',
        'string.empty': 'Expiration Date is not allowed to be empty',
      }),
      isDisableInputs?.expiryDate
    ),
  });
export default CreateEditCoordinatorSchema;
